import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import CommonButton from 'app/components/ReviewButton';
import { TRANSLATION_KEYS } from 'app/constants/transalations';
import { useTranslation } from 'react-i18next';

import { taskError } from '../../types';
import classes from './ErrorHandlerModal.module.scss';

interface ErrorHandlerModalProps {
  isOpen: boolean;
  onClose: () => void;
  errors: taskError[];
}

export const ErrorHandlerModal = ({
  isOpen,
  onClose,
  errors,
}: ErrorHandlerModalProps) => {
  const { t } = useTranslation([
    TRANSLATION_KEYS.REVIEW,
    TRANSLATION_KEYS.COMMON,
  ]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      classes={{ paper: classes.paper }}
      BackdropProps={{ className: classes.backdrop }}
    >
      <DialogTitle disableTypography className={classes.headerContainer}>
        <span className={classes.header}>{t('Task Failure Details')}</span>
        <button className={classes.closeIcon} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </DialogTitle>
      <DialogContent className={classes.modalBody}>
        <p className={classes.subtitle}>
          {t(
            'These errors are preventing the task from being retried. Please recreate the task to resolve them.'
          )}
        </p>
        <ul className={classes.errorList}>
          {errors.map((error, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${error.code}-${index}`} className={classes.errorItem}>
              {error.message}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions className={classes.modalActionBtns}>
        <CommonButton
          onClick={onClose}
          text={t('Okay')}
          variant='primary'
          size='xs'
          wrapperClass={classes.runButton}
          dataTestId='error-handler--okay-button'
        />
      </DialogActions>
    </Dialog>
  );
};
